export type Template3HowItWorksStep = {
  number: string
  title: string
}

export const TEMPLATE3_HOW_IT_WORKS_STEPS: Template3HowItWorksStep[] = [
  { number: '01', title: 'Escolha os números' },
  { number: '02', title: 'Faça a compra' },
  { number: '03', title: 'Aguarde o sorteio' },
  { number: '04', title: 'Confira o resultado' },
]
